import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { NiceModalComponent } from "components/context/NiceModalProvider";
import { ModelDealSharingForm } from "./DealSharingForm";

export default NiceModal.create(({ id, onDeleted, ...props }) => {
  const modal = useModal();

  return (
    <NiceModalComponent open={modal.visible} onClose={modal.hide}>
      <ModelDealSharingForm
        {...props}
        objectId={id}
        onCancel={modal.hide}
        onDeleted={() => {
          onDeleted && onDeleted();
          modal.hide();
        }}
        onCreated={modal.hide}
        onUpdated={modal.hide}
      />
    </NiceModalComponent>
  );
});
